<template>
  <v-dialog persistent v-model="confirmDialog" max-width="750">
    <v-card>
      <v-card-text>
        <v-row justify="center" class="pt-16 mb-5">
          {{ label }}
        </v-row>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <base-input-primary-button @click="$emit('confirm')" icon="mdi-check-bold" label="Confirm"/>
        <base-input-secondary-button @click="$emit('cancel')" icon="mdi-cancel" label="Cancel"/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton'
import BaseInputSecondaryButton from '@/base/input/BaseInputSecondaryButton'
export default {
  name: 'BaseDialogConfirm',
  components: {
    BaseInputSecondaryButton,
    BaseInputPrimaryButton
  },
  props: {
    confirmDialog: {
      type: Boolean,
      require: true
    },
    label: {
      type: String,
      require: true
    }
  }
}
</script>

<style scoped>

</style>
